import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../cookies_popup/cookies_popup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { useEffect, useState } from "react";
import { formatCountdown, WARNING_DURATION } from "../../../utils/constants";
import i18n from "../../../i18n";

function InactivityWarningPopup({ onClose }: IPopupWithoutProps) {
  const [countdown, setCountdown] = useState(WARNING_DURATION / 1000);
  useEffect(() => {
    let countdownInterval: NodeJS.Timeout;
    countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);

    return () => {
      clearInterval(countdownInterval);
    };
  }, []);
  return (
    <article className={popupStyles.popup}>
      <button
        className={`${popupStyles.popup__closeBtn} hover`}
        onClick={onClose}
      />
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <p dir={i18n.dir()}
        className={`${popupStyles.popup__title} ${popupStyles.popup__title_small}`}
      >
        {t('NOT_USED_APP_LONG_TIME')}</p>
      <p dir={i18n.dir()} className={popupStyles.popup__text}>
        {t('SECURITY_AND_PRIVACY_EXIT')}{" "}
        <span>{formatCountdown(countdown)}</span>
      </p>
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t('LEAVE_ME_HERE')}</button>
    </article>
  );
}

export default InactivityWarningPopup;
